import type { IImageReplaceRule, Modification } from '@carboncopyco/types';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { isOverlayTab } from '../../../shared/globalTabUtil';
import {
  getEditsKey,
  getRulesKey,
  getVariablesKey,
} from '../../../shared/interceptor-state-keys';
import { debuggerInterceptorState } from '../utils';

export interface PathListDraft {
  rules: IImageReplaceRule[];
}

const debuggerInterceptorPathListState = (tab: IGlobalTab) => {
  const updateImageReplacePathListStateModification = (
    modifications: Modification[]
  ) => {
    if (isOverlayTab(tab)) {
      const rules: any[] = modifications
        .filter(({ modificationType }) => {
          return modificationType === 'rule';
        })
        .map(({ content }) => content);
      const edits: any[] = modifications
        .filter(({ modificationType }) => {
          return modificationType === 'edit';
        })
        .map(({ content }) => content);
      const variables: any[] = modifications
        .filter(({ modificationType }) => {
          return modificationType === 'variable';
        })
        .map(({ content }) => content);

      debuggerInterceptorState.setItem(getRulesKey(tab.id), rules);
      debuggerInterceptorState.setItem(getEditsKey(tab.id), edits);
      debuggerInterceptorState.setItem(getVariablesKey(tab.id), variables);
    }
  };

  return {
    updateImageReplacePathListStateModification,
  };
};

export default debuggerInterceptorPathListState;
